module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "frontmatter-rw BookTitlePage-rw",
    attrs: {
      "epub:type": "frontmatter titlepage",
      "id": "BookTitlePage1"
    }
  }, [_c('div', {
    staticClass: "title-block-book-rw",
    attrs: {
      "id": "title-block-book1"
    }
  }, [_c('h1', {
    attrs: {
      "epub:type": "fulltitle",
      "id": "h13"
    }
  }, [_vm._v("Respect for Christmas")]), _vm._v(" "), _c('p', {
    staticClass: "title-author-rw",
    attrs: {
      "id": "title-author1"
    }
  }, [_vm._v("Grace Burrowes")])]), _vm._v(" "), _c('div', {
    staticClass: "imprint-rw",
    attrs: {
      "epub:type": "imprint"
    }
  }, [_c('p', {
    attrs: {
      "id": "p2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/Forever_Yours_Red_Logo.png"
    }
  })]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p3"
    }
  }, [_vm._v("New York   Boston")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-661304dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/s001-BookTitlePage-01.vue
// module id = 60
// module chunks = 0